import { render } from "./Contacto.vue?vue&type=template&id=24ccc734"
import script from "./Contacto.vue?vue&type=script&lang=js"
export * from "./Contacto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__